export default [
  {
    name: 'Institution',
    prop: 'institution_id',
    type: 'autocomplete',
    references: 'admin/institutions',
    referenceProp: 'name'
  },
  {
    name: 'Account Holder',
    prop: 'is_account_holder',
    type: 'checkbox',
    onChange: (value, resource) => {
      if (!value && resource.is_primary_account_holder) {
        resource.is_primary_account_holder = false
      }
    }
  },
  {
    name: 'Primary Account Holder',
    prop: 'is_primary_account_holder',
    type: 'checkbox',
    showIf: resource => resource.is_account_holder
  }
]
